import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export const REPORT_GADGETS_DOC = 'reportGadgets';
export const CURRENT_REPORT_GADGETS_VERSION = 'v1';

const reportGadgetConverter = {
  toFirestore(
    gadget: ReportGadgets.ReportGadget,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...gadget });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): ReportGadgets.ReportGadget {
    const data = snapshot.data(options);
    return data as ReportGadgets.ReportGadget;
  },
};

const getReportGadgetsRef = ({
  accountId,
  db,
  versionOverride,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
  versionOverride?: string;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.VISUALISATIONS_COLLECTION)
    .doc(REPORT_GADGETS_DOC)
    .collection(
      versionOverride ? versionOverride : CURRENT_REPORT_GADGETS_VERSION,
    )
    .withConverter(reportGadgetConverter);
};

export default getReportGadgetsRef;
